(function () {
	'use strict';

	// SPAROBES // NAV TOOLS

	var SpaRobesNavTools = (function($) {


		// INIT

		var init = function() {

			// run first
			// initCharacterFilter();

			// gsap
			// gsap.registerPlugin(ScrollTrigger);

			// toys
			initMeganav();
			initMobileNav();

		};


		// MEGANAV

		var initMeganav = function() {

			let triggers = $('.navtrigger');
			let meganavs = $('.meganav');
			let header = $('#spaheader');
			let notrigger = $('#mainnavsale');
			var navid;

			// mouse
			triggers.hover(function(e) {
				e.preventDefault();

				navid = $(this).data('meganav');
				triggers.removeClass('active');
				meganavs.removeClass('active');

				$(this).addClass('active');
				$('#meganav-' + navid).addClass('active');

			});

			triggers.on('click', function(e) {
				e.preventDefault();
			});

			// clear
			$(document).on('click', function(e) {
				if (!$(e.target).closest('#spaheader').length) {
					triggers.removeClass('active');
					meganavs.removeClass('active');
				}
			});

			notrigger.hover(function(e) {
				e.preventDefault();
				triggers.removeClass('active');
				meganavs.removeClass('active');
			});

			header.on('mouseleave', function(e) {
				triggers.removeClass('active');
				meganavs.removeClass('active');
			});

			$(document).on('mouseleave', function(e) {
				triggers.removeClass('active');
				meganavs.removeClass('active');
			});

		};


		// MOBILE NAV

		var initMobileNav = function() {

			let bodytag = $('#spabody');

			let navblocks = $('.mobilenavblock');
			let navcats = $('.mobilenavcat');
			let naventries = $('.mobilenaventries');
			var navid;

			// nav open / close
			$('#hamburger').on('click', function(e) {
				e.preventDefault();

				if (bodytag.hasClass('navopen')) {
					bodytag.removeClass('navopen');
					navblocks.removeClass('active');
					naventries.slideUp();
				}

				else {
					bodytag.addClass('navopen');
				}

			});

			// nav categories
			navcats.on('click', function(e) {
				e.preventDefault();

				navid = $(this).data('navkey');

				// close all
				if ($('#mobilenavblock-' + navid).hasClass('active')) {
					navblocks.removeClass('active');
					naventries.slideUp();
				}

				// open selected
				else {

					navblocks.removeClass('active');
					$('#mobilenavblock-' + navid).addClass('active');

					naventries.slideUp();
					$('#mobilenaventries-' + navid).slideDown();
				}

			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SpaRobesNavTools.init();

	// SPAROBES // CART TOOLS

	var SpaRobesCartTools = (function($) {

		// VARS

		let cartopen = $('#cart-overlay-open');
		let cartclose = $('#cart-overlay-close');
		let mobiletrigger = $('#cart-overlay-open-mobile');


		// INIT

		var init = function() {

			// run first
			// initCharacterFilter();

			// gsap
			// gsap.registerPlugin(ScrollTrigger);

			// toys
			initCartButton();
			initCartFunctions();
			initCartCarousel();

		};


		// CART BUTTON

		var initCartButton = function() {

			let bodytag = $('#spabody');

			cartopen.on('click', function(e) {
				e.preventDefault();
				bodytag.addClass('cartopen');
			});

			mobiletrigger.on('click', function(e) {
				e.preventDefault();
				bodytag.addClass('cartopen');
			});

			cartclose.on('click', function(e) {
				e.preventDefault();
				bodytag.removeClass('cartopen');
			});

		};


		// CART FUNCTIONS

		var initCartFunctions = function() {

			var cartid, amount, lineitem;

			let cartsavings = $('#cartsavings');
			let cartpercent = $('#savingpercent');
			let cartoriginalprice = $('#cartoriginalprice');
			let carttotalprice = $('#carttotalprice');

			// enable button on change
			$('#cartoverlay').on('change', '.overlayamount', function(e) {
				cartid = $(this).data('variantid');
				$('#overlaybutton-' + cartid).removeClass('disabled');
	  		});

			// submit change
			$('#cartoverlay').on('click', '.overlaybutton', function(e) {
				e.preventDefault();

				cartid = $(this).data('variantid');
				amount =  parseInt($('#overlayamount-' + cartid).children('option:selected').val());

				// get lineitem
				for (var i = 0; i < CartJS.cart.items.length; i++) {
					if (CartJS.cart.items[i].id != cartid) { continue; }
					lineitem = i + 1;
					break;
				}

				// update item
				CartJS.updateItem(lineitem, amount, {}, {

					'success': function(data, textStatus, jqXHR) {
						console.log('updated: ' + cartid);

						// remove item
						if (amount == 0) {
							$('#overlayitem-' + cartid).slideUp(function() {
								$(this).remove();
							});
						}

						// update cart
						else {
							$('#overlaybutton-' + cartid).addClass('disabled');
						}

						// refresh cart
						jQuery.getJSON('/cart.js', function(cart) {
							refreshCart(cart);
						});

					},

					'error': function(jqXHR, textStatus, errorThrown) {
						console.log('error: ' + cartid);
					}

				});

	  		});


			// refresh cart
			function refreshCart(cart) {

				console.log(cart);

				// cart empty
				if (cart.item_count == 0) {
					$('#overlayempty').slideDown();
					$('#overlayproducts').slideUp();
					$('#cartfooter').slideUp();

					$('#navcartcount').text('');
					$('#cart-overlay-open').removeClass('filled');
				}

				// cart items
				else {

					// subtotal
					let originalprice = '$' + (cart.original_total_price / 100).toFixed(2).replace(/\.00/i, '');
					let totalprice = '$' + (cart.total_price / 100).toFixed(2).replace(/\.00/i, '');

					cartoriginalprice.text(originalprice);
					carttotalprice.text(totalprice);

					// savings
					if (cart.total_price != cart.original_total_price) {
						cartoriginalprice.show();
						let savings = Math.floor(cart.original_total_price - cart.total_price * 100 / cart.original_total_price);
						cartpercent.text(savings);
						cartsavings.slideDown();
					}

					else {
						cartsavings.slideUp();
					}

					// icon
					$('#navcartcount').text(cart.item_count);
					$('#cart-overlay-open').addClass('filled');

				}

			}
		};


		// CART CAROUSEL

		var initCartCarousel = function() {

			if (('#cart-overlay-related').length == 0) { return; }

			var livepanel = 0;
			var stopped = false;
			var looper;
			let timer = 4 * 1000;

			let panels = $('.cartrelated-image');
			let navboxes = $('.cartrelatednavbox');

			function looppanels() {
				livepanel = livepanel + 1;
				if (livepanel > panels.length) { livepanel = 1; }
				switchpanels();
			}

			navboxes.on('click', function(e) {
				e.preventDefault();
				stopped = true;
				livepanel = parseInt($(this).data('nav'));
				clearInterval(looper);
				switchpanels();
			});

			function switchpanels() {
				panels.removeClass('active');
				$('#cartrelated-image-' + livepanel).addClass('active');
				navboxes.removeClass('active');
				$('#cartrelatednav-' + livepanel).addClass('active');
			}

			function startCarousel() {
				if (stopped) { return; }
				looper = setInterval(looppanels, timer);
			}

			// cart
			cartopen.on('click', function(e) {
				e.preventDefault();
				startCarousel();
			});

			mobiletrigger.on('click', function(e) {
				e.preventDefault();
				startCarousel();
			});

			cartclose.on('click', function(e) {
				e.preventDefault();
				clearInterval(looper);
				stopped = false;
			});

		};


		// RETURN

		return {
			init: init
		};

	}(jQuery));

	SpaRobesCartTools.init();

	// SPAROBES // PANEL TOOLS

	var SpaRobesPanelTools = (function($) {

		// VARS

		let cartopen = $('.cart-overlay-open');
		let cartclose = $('#cart-overlay-close');


		// INIT

		var init = function() {

			// run first
			// initCharacterFilter();

			// gsap
			// gsap.registerPlugin(ScrollTrigger);

			// toys
			initCarouselTextPanel();
			initCompaniesPanel();

		};


		// CAROUSEL TEXT

		var initCarouselTextPanel = function() {

			// console.log($('#panel-imagecarouseltext').length);

			if ($('#panel-imagecarouseltext').length == 0) { return; }

			// console.log('panel active');

			var livepanel = 0;
			let timer = 4 * 1000;

			let panels = $('.featureimage');
			let navboxes = $('.featurethumb');

			var looper;
			var loopactive = false;

			// console.log('Panels: ' + panels.length);
			if (panels.length > 1) {
				loopactive = true;
				looper = setInterval(looppanels, timer);
			}

			function looppanels() {
				livepanel = livepanel + 1;
				if (livepanel == panels.length) { livepanel = 0; }
				switchpanels();
			}

			navboxes.on('click', function(e) {
				e.preventDefault();
				livepanel = parseInt($(this).data('image'));
				if (loopactive) { clearInterval(looper); }
				switchpanels();
			});

			function switchpanels() {
				panels.removeClass('active');
				$('#featureimage-' + livepanel).addClass('active');
				navboxes.removeClass('active');
				$('#featurethumb-' + livepanel).addClass('active');
			}

		};


		// COMPANIES

		var initCompaniesPanel = function() {

			// console.log($('#home-companies').length);

			if ($('#home-companies').length == 0) { return; }

			let owl = $('#home-companies-carousel');
			var owlstopped = false;

			owl.owlCarousel({
				loop: true,
				margin: 0,
				items: 5,
				dots: false,
	 			autoplay: true,
	 			slideTransition: 'linear',
				autoplayTimeout: 3000,
				autoplaySpeed: 3000,

				// autoplayHoverPause: true,

				responsive: {
					0: {
						items: 2
					},
					421: {
						items: 4
					},
					// 600: {
					// 	items: 4
					// },
					// 767: {
					// 	items: 5
					// },
					// 1201: {
					// 	items: 6
					// }
				}

			});

			// nav
			$('#home-companies-left').on('click', function(e) {
				e.preventDefault();
				owlstopped = true;
				owl.trigger('stop.owl.autoplay');
				owl.trigger('prev.owl.carousel', [1000]);
			});

			$('#home-companies-right').on('click', function(e) {
				e.preventDefault();
				owlstopped = true;
				owl.trigger('stop.owl.autoplay');
				owl.trigger('next.owl.carousel', [1000]);
			});

			// cart
			cartopen.on('click', function(e) {
				e.preventDefault();
				owl.trigger('stop.owl.autoplay');
			});

			cartclose.on('click', function(e) {
				e.preventDefault();
				if (owlstopped === false) { owl.trigger('play.owl.autoplay'); }
			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SpaRobesPanelTools.init();

	// SPAROBES / HOMEPAGE

	var SparobesHomepage = (function($) {

		// VARS

		let cartopen = $('.cart-overlay-open');
		let cartclose = $('#cart-overlay-close');


		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());
			if (pagejson.pageid != 'index') { return; }

			// toys
			initCarousel();
			initRelax();

		};


		// CAROUSEL

		var initCarousel = function() {

			var livepanel = 0;
			var stopped = false;
			let timer = 4 * 1000;

			let panels = $('.carouselpanel');
			let navboxes = $('.carouselnavbox');

			var looper = setInterval(looppanels, timer);

			function looppanels() {
				livepanel = livepanel + 1;
				if (livepanel == panels.length) { livepanel = 0; }
				switchpanels();
			}

			navboxes.on('click', function(e) {
				e.preventDefault();
				stopped = true;
				livepanel = parseInt($(this).data('nav'));
				clearInterval(looper);
				switchpanels();
			});

			function switchpanels() {
				panels.removeClass('active');
				$('#carousel-' + livepanel).addClass('active');
				navboxes.removeClass('active');
				$('#carouselnav-' + livepanel).addClass('active');
			}

			// cart
			cartopen.on('click', function(e) {
				e.preventDefault();
				clearInterval(looper);
			});

			cartclose.on('click', function(e) {
				e.preventDefault();
				if (stopped === false) { looper = setInterval(looppanels, timer); }
			});

		};


		// RELAX

		var initRelax = function() {

			let tabs = $('.home-relaxtab');
			let panels = $('.home-relaxpanel');
			var livepanel = '';

			tabs.on('click', function(e) {
				e.preventDefault();
				livepanel = $(this).data('tab');
				tabs.removeClass('active');
				panels.removeClass('active');
				$(this).addClass('active');
				$('#relaxpanel-' + livepanel).addClass('active');
			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesHomepage.init();

	// SPAROBES / ACCOUNT

	var SparobesAccount = (function($) {


		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());

			// traffic cop
			switch(pagejson.pageid) {

				case 'login':
					initLogin();
					break;

				case 'addresses':
					initAddresses();
					break;

				default:
					return;
			}

		};


		// LOGIN

		var initLogin = function() {

			let switchlink = $('.loginswitch');
			let panels = $('.switchpanel');

			var livepanel;

			switchlink.on('click', function(e) {
				e.preventDefault();
				livepanel = $(this).data('panel');
				panels.slideUp();
				$('#panel-' + livepanel).slideDown();
			});

		};


		// ADDRESSES

		var initAddresses = function() {

			let addresslink = $('.addresslink');
			let cancelbutton = $('.cancelbutton');
			$('.formpanel');

			var livepanel;

			addresslink.on('click', function(e) {
				e.preventDefault();
				livepanel = $(this).data('panel');
				$('#links-' + livepanel).slideUp();
				$('#panel-' + livepanel).slideDown();
			});

			cancelbutton.on('click', function(e) {
				e.preventDefault();
				livepanel = $(this).data('panel');
				$('#panel-' + livepanel).slideUp();
				$('#links-' + livepanel).slideDown();
			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesAccount.init();

	// SPAROBES / BULK PAGE

	var SparobesBulkPage = (function($) {


		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());
			if (pagejson.suffixid != 'bulk-gifts') { return; }

			// toys
			initTabs();

		};


		// TABS

		var initTabs = function() {

			let tabs = $('.infotab');
			let panels = $('.tabpanel');
			var livedata = '';

			tabs.on('click', function(e) {
				e.preventDefault();

				livedata = $(this).data('tab');
				tabs.removeClass('active');
				$(this).addClass('active');

				panels.hide();
				$('#tabpanel-' + livedata).show();
			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesBulkPage.init();

	// SPAROBES / CART PAGE

	var SparobesCartPage = (function($) {


		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());
			if (pagejson.pageid != 'cart') { return; }

			// toys
			initUpdateButton();
			initBlocks();
			initGiftBag();

		};


		// UPDATE BUTTON

		var initUpdateButton = function() {

			$('.updatebutton').on('click', function(e) {
				e.preventDefault();

				let itemid = $(this).data('itemid');
				let quantity = $('#updates_' + itemid).val();
				var lineitem;

				// get lineitem
				for (var i = 0; i < CartJS.cart.items.length; i++) {
					if (CartJS.cart.items[i].id != itemid) { continue; }
					lineitem = i + 1;
					break;
				}

				console.log (itemid + ' / ' + lineitem + ' / ' + quantity);

				// update item
				CartJS.updateItem(lineitem, quantity, {}, {

					'success': function(data, textStatus, jqXHR) {
						console.log('updated: ' + itemid);

						// refresh page
						location.reload(true);

					},

					'error': function(jqXHR, textStatus, errorThrown) {
						console.log('error: ' + itemid);
					}

				});

			});

		};


		// BLOCKS

		var initBlocks = function() {

			let questions = $('.accordiontitle');

			var liveblock;

			questions.on('click', function(e) {
				e.preventDefault();
				liveblock = $(this).data('block');
				if ($(this).hasClass('active')) {
					$(this).removeClass('active');
					$('#accordion-' + liveblock).slideUp();
				} else {
					$(this).addClass('active');
					$('#accordion-' + liveblock).slideDown();
				}
			});

		};


		// GIFT BAG

		var initGiftBag = function() {

			let bagbutton = $('#addgiftbag');
			var bagid, bagamount;

			bagbutton.on('click', function(e) {
				e.preventDefault();

				bagid = bagbutton.data('giftbagid');
				bagamount = $('#giftbagcount').val();

				CartJS.addItem(bagid, bagamount, {}, {

					'success': function(data, textStatus, jqXHR) {
						console.log('bag added: ' + bagid);
						location.reload();
					},

					'error': function(jqXHR, textStatus, errorThrown) {
						console.log('bag error: ' + bagid);
						console.log(textStatus + ' / ' + errorThrown);
					}

				});

			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesCartPage.init();

	// SPAROBES / COLLECTION

	var SparobesCollection = (function($) {

		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());
			if (pagejson.pageid != 'collection') { return; }

			// toys
			initFilters();

		};


		// FILTERS

		// https://luxurysparobes.com/collections/spa-terry-cloth-robes?constraint=color-brown+color-white%22

		var initFilters = function() {

			let trigger = $('.filtertrigger');
			$('.clearfiltertrigger');
			const pageurl = new URL(window.location.href);

			// populate checkboxes
			let pagefilters = pageurl.searchParams.get('constraint');
			// console.log('filters: ' + pagefilters);

			if ( (pagefilters !== null) && (pagefilters.length > 0) ) {

				let filterarray = pagefilters.split(' ');
				// console.log('filterarray: ' + filterarray);

				for (var i in filterarray) {
	    			// console.log(filterarray[i]);
					$('#filter_' + filterarray[i]).prop('checked', true);
				}

			}

			// trigger clicked
			trigger.on('click', function(e) {

				let option = $(this).attr('value');
				var filters;

				// clear
				if (option == 'all') {

					let clearcat = $(this).attr('name');

					filters = $('.filtertrigger:radio:checked').map(function() {
						if ( (this.value.startsWith(clearcat)) || (this.value == 'all') ) { return; }
						return this.value;
					}).get();

				}

				// filter
				else {
					filters = $('.filtertrigger:radio:checked').map(function() {
						if (this.value == 'all') { return; }
						return this.value;
					}).get();

				}

				filters = filters.join('+').replace('"', '');

				var openurl = pageurl.pathname;

				if (filters.length > 0) {
					openurl = openurl + '?constraint=' + filters;
				}

				window.open(openurl, '_self');

			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesCollection.init();

	// SPAROBES / FAQ PAGE

	var SparobesFAQ = (function($) {


		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());
			if (pagejson.suffixid != 'faq') { return; }

			// toys
			initQuestions();

		};


		// QUESTIONS

		var initQuestions = function() {

			let tabs = $('.infotab');

			let entries = $('.entry');
			let questions = $('.question');
			let answers = $('.answer');

			var livedata = '';

			tabs.on('click', function(e) {
				e.preventDefault();

				livedata = $(this).data('tab');
				tabs.removeClass('active');
				$(this).addClass('active');

				if (livedata == 'all') {
					entries.show();
				} else {
					entries.hide();
					$('.' + livedata).show();
				}

				questions.removeClass('active');
				answers.slideUp();

			});

			questions.on('click', function(e) {
				e.preventDefault();
				livedata = $(this).data('answer');
				if ($(this).hasClass('active')) {
					$(this).removeClass('active');
					$('#answer-' + livedata).slideUp();
				} else {
					$(this).addClass('active');
					$('#answer-' + livedata).slideDown();
				}
			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesFAQ.init();

	// SPAROBES / PRODUCT

	var SparobesProduct = (function($) {

		// VARS

		let cartopen = $('#cart-overlay-open');
		let cartclose = $('#cart-overlay-close');
		let mobiletrigger = $('#cart-overlay-open-mobile');


		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());
			if (pagejson.pageid != 'product') { return; }

			// toys
			initProductImage();
			initProduct();
			initMainDetails();
			initFabrics();
			initRelated();

		};


		// PRODUCT IMAGE

		var initProductImage = function() {

			var livepanel = 0;
			let timer = 4 * 1000;

			let panels = $('.product-image');
			let navboxes = $('.product-thumb');

			var looper;
			var loopactive = false;

			// console.log('Panels: ' + panels.length);
			if (panels.length > 1) {
				loopactive = true;
				looper = setInterval(looppanels, timer);
			}

			function looppanels() {
				livepanel = livepanel + 1;
				if (livepanel == panels.length) { livepanel = 0; }
				switchpanels();
			}

			navboxes.on('click', function(e) {
				e.preventDefault();
				livepanel = parseInt($(this).data('image'));
				if (loopactive) { clearInterval(looper); }
				switchpanels();
			});

			function switchpanels() {
				panels.removeClass('active');
				$('#product-image-' + livepanel).addClass('active');
				navboxes.removeClass('active');
				$('#product-thumb-' + livepanel).addClass('active');
			}

		};


		// PRODUCT

		var initProduct = function() {

			var productjson, producthandle, currentvariant, varianttitle;

			// init json
			if ($('#ProductJson').length) {
				productjson = JSON.parse($('#ProductJson').html());
				producthandle = productjson.handle;
			}
			console.log(productjson.variants);

			// init variant
			let pagevariant = JSON.parse($('#spavariant').html());
			varianttitle = pagevariant.currentvariant;
			currentvariant = productjson.variants.find(variant => variant.title === varianttitle);

			console.log('variant: ' + varianttitle);
			console.log('current: ' + currentvariant.title);

			// recently viewed
			recentlyViewed();

			// shopify
			$('#spabody');
			let optionbox = $('.optionbox');
			let pricespan = $('#regularprice');
			let comparespan = $('#compareprice');
			let cartamount = $('#cartamount');
			let cartbutton = $('#cartbutton');

			// form
			let formamount = $('#form-quantity');
			let formvariant = $('#currentvariant');

			var optiontype, optionstyle, optionindex;
			var varianttitle;
			var currentprice, compareprice;
			var addid, addamount;
			var cartentry;

			// initial variants
			var option1 = $('.productoption1:checked').val();
			var option2 = $('.productoption2:checked').val();
			var option3 = $('.productoption3:checked').val();

			// sizes
			let colorboxlink = $('.colorboxlink');
			var spasizes = false;
			var currentsize = '';
			if ($('#product-size-selected').length) {
				spasizes = true;
				currentsize = $('#product-size-selected').data('spastyle');
			}

			// option clicked
			optionbox.on('click', function(e) {
				// e.preventDefault();

				// set label
				optiontype = $(this).data('type');
				optionstyle = $(this).data('style');
				optionindex = parseInt($(this).data('option'));
				// console.log(optiontype + ' / ' + optionstyle);
				$('#product-' + optiontype + '-selected').text(optionstyle);

				// get variant
				if (optionindex == 1) { option1 = optionstyle; }
				else if (optionindex == 2) { option2 = optionstyle; }
				else if (optionindex == 3) { option3 = optionstyle; }

				varianttitle = option1;
				if (typeof option2 !== 'undefined') { varianttitle = varianttitle +  ' / ' + option2; }
				if (typeof option3 !== 'undefined') { varianttitle = varianttitle +  ' / ' + option3; }

				currentvariant = productjson.variants.find(variant => variant.public_title === varianttitle);

				console.log('variant: ' + varianttitle);
				console.log('current: ' + currentvariant.id);

				// update image
				// panels.removeClass('active');
				// $('#product-image-' + currentvariant.featured_image.id).addClass('active');

				// update price
				currentprice = '$' + parseFloat(Math.floor((currentvariant.price) / 100));
				compareprice = '$' + parseFloat(Math.floor((currentvariant.compare_at_price) / 100));

				pricespan.text(currentprice);

				if (currentvariant.price == currentvariant.compare_at_price) {
					comparespan.removeClass('active').text('');
				}
				else {
					$('#saleprice').addClass('active').text(compareprice);
				}

				// update size
				if ( (optiontype == 'size') && (spasizes) ) {
					currentsize = $(this).data('spastyle');
				}

				// available
				if (currentvariant.available !== true) { cartbutton.addClass('disabled').text('Out of Stock'); }
				else { cartbutton.removeClass('disabled').text('Add to Cart'); }

				// shopify form
				formvariant.val(currentvariant.id);

				// cart button
				cartbutton.data('variant', currentvariant.id);
				// console.log(currentvariant.id);

			});

			// colorbox clicked
			colorboxlink.on('click', function(e) {
				if (spasizes) {
					e.preventDefault();
					let colorurl = $(this).prop('href') + '/spasize+' + currentsize;
					window.location.href = colorurl;
				}
			});

			// shopify form
			cartamount.on('change', function(e) {
				addamount = cartamount.children('option:selected').val();
				console.log('Quantity: ' + addamount);
				formamount.val(addamount);
			});

			// add to cart
			// console: CartJS.cart
			cartbutton.on('click', function(e) {
				e.preventDefault();

				addid = cartbutton.data('variant');
				addamount = cartamount.children('option:selected').val();

				console.log('add: ' + addid + ' / ' + addamount);

				CartJS.addItem(addid, addamount, {}, {

					'success': function(data, textStatus, jqXHR) {
						console.log('added: ' + addid + ' / ' + currentvariant.id);
						jQuery.getJSON('/cart.js', function(cart) {
							updateCart(cart);
						});
					},

					'error': function(jqXHR, textStatus, errorThrown) {
						console.log('error: ' + addid + ' / ' + currentvariant.id);
					}

				});

			});


			// update cart

			function updateCart(cart) {

				// create entry
				cartentry = $('#cartitemclone').clone().attr('id', 'overlayitem-' + currentvariant.id).show();

				cartentry.find('.productthumb')
					.attr('href', 'https://luxurysparobes.com/products/' + productjson.handle + '?variant=' + currentvariant.id)
					.css('background-image', 'url(' + currentvariant.featured_image.src + '&width=130)');

				cartentry.find('.productname').text(productjson.title);

				if (currentvariant.title != 'Default Title') {
					cartentry.find('.productdetail').text(currentvariant.title);
				}

				cartentry.find('.spaselect')
					.data('variantid', currentvariant.id)
					.attr('id', 'overlayamount-' + currentvariant.id)
					.val(addamount.toString());

				cartentry.find('.spabutton')
					.data('variantid', currentvariant.id)
					.attr('id', 'overlaybutton-' + currentvariant.id);

				// add entry
				$('#overlayitems').prepend(cartentry).show();

				// adjust subtotals
				var originalprice = '$' + (cart.original_total_price / 100).toFixed(2).replace(/\.00/i, '');
				var totalprice = '$' + (cart.total_price / 100).toFixed(2).replace(/\.00/i, '');

				let cartsavings = $('#cartsavings');
				let cartpercent = $('#savingpercent');
				let cartoriginalprice = $('#cartoriginalprice');
				let carttotalprice = $('#carttotalprice');

				cartoriginalprice.text(originalprice);
				carttotalprice.text(totalprice);

				if (cart.total_price != cart.original_total_price) {
					let savings = Math.floor(cart.original_total_price - cart.total_price * 100 / cart.original_total_price);
					cartpercent.text(savings);
					cartoriginalprice.show();
					cartsavings.show();
				}

				else {
					cartoriginalprice.hide();
					cartsavings.hide();
				}

				// adjust panels
				$('#overlayempty').hide();
				$('#overlayproducts').show();
				$('#cartfooter').show();

				// icon
				$('#navcartcount').text(cart.item_count);
				$('#cart-overlay-open').addClass('filled');

				// fire!
				cartopen.trigger( "click" );
				// bodytag.addClass('cartopen');

			}


			// recently viewed

			function recentlyViewed() {

				var viewedProducts = new Array();
				var SpaCookie = Cookies.noConflict();
				var cookie = SpaCookie.get('recently_viewed_products');
				if ( (cookie !== undefined) && (cookie != 'undefined') ) {
					// console.log('cookie: ' + cookie);
					viewedProducts = JSON.parse(cookie);
					refreshViewed(viewedProducts);
					var index = viewedProducts.indexOf(producthandle);
					if (index > -1) {
						viewedProducts.splice(index, 1);
					}
				}
				viewedProducts.unshift(producthandle);
				SpaCookie.set('recently_viewed_products', JSON.stringify(viewedProducts), { expires: 30, path: '/' });
				// console.log('viewed: ' + JSON.stringify(viewedProducts));

			}

			// https://shopify.dev/docs/api/ajax/reference/product
			function refreshViewed (viewedProducts) {

				var count = 0;
				var entry;

				$.each(viewedProducts, function(index, handle) {

					// console.log('count: ' + count);
					count = count + 1;

					if (count <= 4) {

						jQuery.getJSON(window.Shopify.routes.root + 'products/' + handle + '.js', function(product) {

							// clone entry
							entry = $('#clone-recent').clone().removeAttr('id');

							// update image
							$(entry).find('#clone-image').css('background-image', 'url(' + product.featured_image + '&width=520)');

							// update text
							$(entry).find('#clone-imagename').text(product.title).removeAttr('id');
							$(entry).find('#clone-textname').text(product.title).removeAttr('id');

							// update urls
							$(entry).find('#clone-image').attr('href', product.url).removeAttr('id');
							$(entry).find('#clone-texturl').attr('href', product.url).removeAttr('id');

							// update price
							var displayprice = '$' + (product.price / 100).toFixed(2).replace(/\.00/i, '');
							$(entry).find('#clone-price').text(displayprice).removeAttr('id');

							// update ratings
							$(entry).find('#clone-stars').attr('data-id', product.id).attr('data-product-title', product.title).attr('data-product-type', product.type).removeAttr('id');

							// reveal clone
							$(entry).appendTo('#relatedpanel-recent').show();

						});

					}

				});

			}

		};


		// MAIN DETAILS

		var initMainDetails = function() {

			// images

			var liveimage = 0;
			let timer = 4 * 1000;
			var stopped = false;

			let images = $('.feature-image');
			let navboxes = $('.feature-thumb');

			var looper = setInterval(loopimages, timer);

			function loopimages() {
				liveimage = liveimage + 1;
				if (liveimage == images.length) { liveimage = 0; }
				switchimages();
			}

			navboxes.on('click', function(e) {
				e.preventDefault();
				stopped = true;
				liveimage = parseInt($(this).data('image'));
				clearInterval(looper);
				switchimages();
			});

			function switchimages() {
				images.removeClass('active');
				$('#feature-image-' + liveimage).addClass('active');
				navboxes.removeClass('active');
				$('#feature-thumb-' + liveimage).addClass('active');
			}


			// tabs
			let tabs = $('.product-detailtab');
			let panels = $('.product-detailpanel');
			var livepanel = '';

			tabs.on('click', function(e) {
				e.preventDefault();
				livepanel = $(this).data('tab');
				tabs.removeClass('active');
				$(this).addClass('active');
				panels.slideUp();
				$('#detailpanel-' + livepanel).slideDown();
			});


			// cart
			cartopen.on('click', function(e) {
				e.preventDefault();
				clearInterval(looper);
			});

			mobiletrigger.on('click', function(e) {
				e.preventDefault();
				clearInterval(looper);
			});

			cartclose.on('click', function(e) {
				e.preventDefault();
				if (stopped === false) { looper = setInterval(loopimages, timer); }
			});

		};


		// FABRICS

		var initFabrics = function() {

			let tabs = $('.product-fabrictab');
			let panels = $('.product-fabricpanel');
			var livepanel = '';

			tabs.on('click', function(e) {
				e.preventDefault();
				livepanel = $(this).data('tab');
				tabs.removeClass('active');
				panels.removeClass('active');
				$(this).addClass('active');
				$('#fabricpanel-' + livepanel).addClass('active');
			});

		};


		// RELATED

		var initRelated = function() {

			let tabs = $('.product-relatedtab');
			let panels = $('.product-relatedpanel');
			var livepanel = '';

			tabs.on('click', function(e) {
				e.preventDefault();
				livepanel = $(this).data('tab');
				tabs.removeClass('active');
				panels.removeClass('active');
				$(this).addClass('active');
				$('#relatedpanel-' + livepanel).addClass('active');
			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesProduct.init();

	// SPAROBES / SHIPPING PAGE

	var SparobesShippingPage = (function($) {


		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());
			if (pagejson.suffixid != 'shipping-returns') { return; }

			// toys
			initTabs();

		};


		// TABS

		var initTabs = function() {

			let tabs = $('.infotab');
			let panels = $('.shipping-tabcontent');
			var livedata = '';

			tabs.on('click', function(e) {
				e.preventDefault();

				livedata = $(this).data('tab');
				tabs.removeClass('active');
				$(this).addClass('active');

				panels.hide();
				$('#tabcontent-' + livedata).show();

			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesShippingPage.init();

	// SPAROBES / SIZECHART PAGE

	var SparobesSizechartPage = (function($) {


		// INIT

		var init = function() {

			// setup
			var pagejson = JSON.parse($('#spajson').html());
			if (pagejson.suffixid != 'sizechart') { return; }

			// toys
			initTabs();

		};


		// TABS

		var initTabs = function() {

			let tabs = $('.infotab');
			let panels = $('.sizechart-tabcontent');
			var livedata = '';
			const plush = [ 'deluxeplush', 'fleeceplush', 'kimonoplush' ];
			const waffle = [ 'waffleresort', 'wafflespa', 'wafflecotton' ];

			// page load
			const url = new URL(window.location.href);

			if (url.searchParams.size > 0) {

				for (const [key, value] of url.searchParams.entries()) {
					if (key == 'sizechart') {
						if (plush.includes(value)) { livedata = 'plush'; }
						else if (waffle.includes(value)) { livedata = 'waffle'; }
					}
				}

				if (livedata.length > 0) {
					tabs.removeClass('active');
					$('#tab-' + livedata).addClass('active');
					panels.hide();
					$('#tabcontent-' + livedata).show();
				}

			}

			// click
			tabs.on('click', function(e) {
				e.preventDefault();

				livedata = $(this).data('tab');
				tabs.removeClass('active');
				$(this).addClass('active');

				panels.hide();
				$('#tabcontent-' + livedata).show();

			});

		};


		// RETURN

		return {
			init: init,
		};

	}(jQuery));

	SparobesSizechartPage.init();

})();
